module.exports = __webpack_public_path__ + "static/media/userprofile.4b5cc9d5.png";